export default "__VITE_ASSET__DemiMgtG__"